import { render } from "./DashboardInfoBlock.vue?vue&type=template&id=698d6434&scoped=true"
import script from "./DashboardInfoBlock.vue?vue&type=script&lang=js"
export * from "./DashboardInfoBlock.vue?vue&type=script&lang=js"

import "./DashboardInfoBlock.vue?vue&type=style&index=0&id=698d6434&lang=scss&scoped=true"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698d6434"]])

export default __exports__